module.exports = __webpack_public_path__ + "print_texture.png?c9ac3327288a5d1f0e5741d6d9f6d7b8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print_texture.png
// module id = 332
// module chunks = 0